// extracted by mini-css-extract-plugin
export var parcelRow = "_tr-0";